<template>
  <!-- // 暂时关闭 -->
  <div class="light-page" v-if="true">
    <div v-wechat-title="'最强蜗牛'"></div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' :gameName="gameName" :game_id="'39'" :downloadUrl="downloadUrl" :loginTypes="loginTypes"
      :autoOpenOS="autoOpenOS" v-on:loginSuccess="loginSuccess" channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <Os v-if='isShowOs' v-on:logoutCallback='osCancell' @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <!-- 头部 -->
    <div class="header">
      <div class="text top">最强蜗牛</div>
      <div class="text bottom">{{ userInfo.user_id ? `${userInfo.server_name}-${userInfo.role_name}` : '新春开局，胜天半子' }}
      </div>
      <div class="btn website" @click="downloadApp" data-snail-report-name="官网">
      </div>
      <div class="btn login" v-show="!userInfo.user_id" @click="changeLoginPopup(true)"></div>
      <div class="btn switch" v-show="userInfo.user_id" @click="changeOsPopup(true)"></div>
    </div>
    <!-- 内容 -->

    <div class="active-page">
      <div class="section-container">
        <div class="recall-box-tree" />
        <div :class="'section section1 ' + aspectRatio">
          <div class="banner"></div>
          <div class="recall-box" id="recall-box">
            <div class="detail-btn" data-snail-report-name="详情按钮" @click="showPopup('detailShow')"></div>

            <div class="content-click">
              <div class="content-click-item" @click="showPopup('activityBenefitsShow')"
                data-snail-report-name="五灯大奖按钮"></div>
              <div class="content-click-item" @click="onMorePoints()" data-snail-report-name="花灯记录按钮"></div>
            </div>
            <div class="recall-content">

              <div class="light-time gzf" v-if="userInfo.game_id == 26" />
              <div class="light-time zsf" v-else />
              <div class="light-items">
                <div class="light-items-wrap">
                  <div v-for="(item, index) in cardList" :key="index"
                    :class="['light-item', `light-item--${index + 1}`]" @click="lightItemClick(index)">
                    <div :class="['light-active', `light-active${index + 1}`]" v-if="item.active" />
                    <div class="item-active" v-if="item.active" />
                    <div class="light-item-title">{{ item.name }}</div>
                    <div class="light-item-text">数量：{{ item.num }}</div>
                  </div>
                </div>
              </div>
              <div class="light-btn" @click="onGetInitLightCodeAPI" data-snail-report-name="赠送花灯按钮" />
              <div class="refresh" @click="onGetInitLighiDataRefreshAPI" data-snail-report-name="一键刷新" />
            </div>
            <div class="go-btn" @click="toIndex" data-snail-report-name="前往春节专题页按钮"></div>
          </div>

          <div class="find_team_btn" @click="openFindTeamShow()" data-snail-report-name="加入社群按钮">
            <img src="../../../../assets/images/active/snail/springFestivalActive/light/find_team_icon.png" />
          </div>

          <!-- 召回分享 -->
          <div class="recall-share-box" ref="recallImageDom">
            <div class="gift-text-content">
              <div class="gift-text">{{ userInfo.role_name }}</div>
              <div class="gift-text">送你一盏{{ cardInfo.name }}</div>
            </div>
            <div :class="['light-item', `gift-item--${cardInfo.id}`]" />
            <img src="../../../../assets/images/active/snail/springFestivalActive/light/gift_card_popup.png" />
            <div class="share-img">
              <div class="qrcode-box">
                <div id="recall-qrcode" class="qrcode"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 召回绑定弹窗组 -->
    <div>
      <!-- 召回绑定——详情弹窗 -->
      <!-- 跨渠道赠送 -->
      <div class=" cross-channel-wrap popup_wrap" v-show="crossChannelShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="cross-channel-box popup_wrap-box" v-show="crossChannelShow">
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="接收失败_跨渠道赠送"
                @click="closePopup('crossChannelShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="crossChannelShow" @click="closePopup('crossChannelShow')"></div>
      </div>


      <!-- 赠送自己 -->
      <div class="not-gift-to-oneself-wrap popup_wrap" v-show="notGiftToOneselfShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="not-gift-to-oneself-box popup_wrap-box" v-show="notGiftToOneselfShow">
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="接收失败_赠送自己"
                @click="closePopup('notGiftToOneselfShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="notGiftToOneselfShow" @click="closePopup('notGiftToOneselfShow')"></div>
      </div>
      <!-- 被领取走 -->
      <div class="collected-and-taken-away-wrap popup_wrap" v-show="collectedAndTakenAwayShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="collected-and-taken-away-box popup_wrap-box" v-show="collectedAndTakenAwayShow">
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="接收失败_被领取走"
                @click="closePopup('collectedAndTakenAwayShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="collectedAndTakenAwayShow" @click="closePopup('collectedAndTakenAwayShow')"></div>
      </div>
      <!-- 花灯接受 -->
      <div class="recall-invitation-wrap popup_wrap" v-show="acceptInvitationShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-invitation-box popup_wrap-box" v-show="acceptInvitationShow">

            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="残忍拒绝" @click="toIndex('acceptInvitationShow')">
              </div>
              <div class="btn my-team-btn" data-snail-report-name="接受邀请" @click="acceptInvitation()"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="detail-wrap popup_wrap" v-show="detailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="detail-box popup_wrap-box" v-show="detailShow">
          <div class="detail-content" v-if="detailShow">
            <img src="../../../../assets/images/active/snail/springFestivalActive/light/rule.png" alt="">
          </div>
          <div class="detail-btn" v-show="detailShow" @click="closePopup('detailShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="detailShow" @click="closePopup('detailShow')"></div>
    </div>

    <!-- 召回绑定——微信分享 -->
    <div class="recall-wechat-share-wrap popup_wrap" v-show="recallWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div
          :class="'recall-wechat-share-box popup_wrap-box ' + ((activeInfo.invite && ([1, 3].includes(activeInfo.invite.status))) ? 'new_player' : '')"
          v-show="recallWechatShareShow">
        </div>
      </transition>
      <div class="close-bg" v-show="recallWechatShareShow" @click="closeWechatShare('recallWechatShareShow')"></div>
    </div>
    <!-- 召回绑定——分享弹窗 -->
    <div class="recall-share-wrap popup_wrap" v-show="recallNotWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="recall-share-box popup_wrap-box" v-show="recallNotWechatShareShow">
          <img :src="recallShareImg" alt="分享图片" :class="'hide-' + aspectRatio" />
          <div class="share-tips"></div>
          <button class="monitor-btn" @click="onCopy('recall-clipboard-btn')" id="recall-clipboard-btn"
            data-snail-report-name="分享弹窗-复制链接按钮" data-event="复制邀请链接"
            :data-clipboard-text="shareCopy.linkText + shareLink"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="recallNotWechatShareShow" @click="closePopup('recallNotWechatShareShow')"></div>
    </div>




    <!-- 寻找组队搭子 -->
    <div class="find-team-wrap popup_wrap" v-show="findTeamShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="find-team-box popup_wrap-box" v-show="findTeamShow">
          <div class="btn-box">
            <div class="btn qq-btn" data-snail-report-name="社群弹窗-前往QQ群按钮" @click="toGroupOfQQ()"></div>
            <div class="btn wechat-btn" data-snail-report-name="社群弹窗-前往微信群按钮" @click="toGroupOfWechat()"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="findTeamShow" @click="closePopup('findTeamShow')"></div>
    </div>

    <!-- QQ群 -->
    <div class="qq-group-wrap popup_wrap" v-show="qqGroupShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="qq-group-box popup_wrap-box" v-show="qqGroupShow">
          <div class="num">{{ qqNumber }}</div>
          <button class="monitor-btn" @click="onCopy('qq-clipboard-btn')" id="qq-clipboard-btn"
            data-snail-report-name="QQ群弹窗-一键复制按钮" data-event="复制QQ群号" :data-clipboard-text="qqNumber"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="qqGroupShow" @click="closePopup('qqGroupShow')"></div>
    </div>
    <!-- 新春活动_花灯——积分记录弹窗 -->
    <div class="team-points-record-wrap popup_wrap" v-show="teamPointsRecordShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="team-points-record-box popup_wrap-box" v-show="teamPointsRecordShow">
          <div class="record-box">
            <ul>
              <li v-for="(item, idx) of scoreList" :key="idx">
                <div class="left">
                  <div class="name">{{ item.remark }}</div>
                </div>
                <div class="right">{{ item.created_at && formatDate(item.created_at) }}</div>
              </li>
            </ul>
          </div>

          <!-- <div class="close-btn" @click="closePopup('teamPointsRecordShow')"></div> -->
        </div>
      </transition>
      <div class="close-bg" v-show="teamPointsRecordShow" @click="closePopup('teamPointsRecordShow')"></div>
    </div>
    <!-- 新春活动_花灯——积分记录弹窗 无积分 -->
    <div class="team-not-points-record-wrap popup_wrap" v-show="teamNotPointsRecordShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="team-not-points-record-box popup_wrap-box" v-show="teamNotPointsRecordShow">
        </div>
      </transition>
      <div class="close-bg" v-show="teamNotPointsRecordShow" @click="closePopup('teamNotPointsRecordShow')"></div>
    </div>

    <!-- 提示弹窗——光子服是否开启 -->
    <div class="photon-started-wrap popup_wrap" v-show="photonStartedShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="photon-started-box popup_wrap-box" v-show="photonStartedShow">
          <div class="btn-box">
            <div class="btn close-btn" @click="closePopup('photonStartedShow')"></div>
          </div>
        </div>
      </transition>

      <div class="close-bg" v-show="photonStartedShow" @click="closePopup('photonStartedShow')"></div>
    </div>
    <!-- 奖励弹窗——贵重物品详情 -->
    <div class="activity-benefits-wrap popup_wrap" v-show="activityBenefitsShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="activity-benefits-box popup_wrap-box" v-show="activityBenefitsShow">
          <div class="btn-box">
            <div class="btn close-btn" @click="closePopup('activityBenefitsShow')"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="activityBenefitsShow" @click="closePopup('activityBenefitsShow')"></div>
    </div>
    <!-- 接受花灯 -->
    <div class="accept-gift-confirm-wrap popup_wrap" v-show="acceptGiftConfirmShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="accept-gift-confirm-box popup_wrap-box" v-show="acceptGiftConfirmShow">
          <div :class="['light-item', `light-item--${cardAccpetInfo.id}`]">
            <!-- <div class="item-active" /> -->
            <div class="light-item-title">{{ cardAccpetInfo.name }}</div>
          </div>

          <div class="btn-box">
            <div class="btn confirm-btn" data-snail-report-name="领取花灯弹窗-我再想想按钮"
              @click="closePopup('acceptGiftConfirmShow')">
            </div>
            <div class="btn cancel-btn" data-snail-report-name="领取花灯弹窗-立即领取按钮" @click="onGetInitLightGetAPI()"></div>
          </div>
        </div>
      </transition>
    </div>


    <!-- 奖励弹窗 -->
    <div class="activity-benefits-wrap popup_wrap" v-show="activityBenefitsShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="activity-benefits-box popup_wrap-box" v-show="activityBenefitsShow">
          <div class="btn-box">
            <div class="btn close-btn" @click="closePopup('activityBenefitsShow')"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="activityBenefitsShow" @click="closePopup('activityBenefitsShow')"></div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import { GetRoleList, BindRoleAPI } from "@/api/os";
import Login from '@/components/login';
import Os from '@/components/os';
import Header from '../Header/index.vue';
import Footer from '@/components/Footer';
import { APP_ID, PAGE_ID, GAME_AREA } from "@/config/constant";
import { headerConfig } from '../headerConfig';
import {
  onGetInitLightDataAPI, onGetTimeAPI, recallBindPlayerAPI, onGetInitLightCodeAPI, onGetInitLighiDataRefreshAPI, onGetInitLightHelpDataAPI, onGetInitLightGetAPI,
} from './api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

import eruda from 'eruda';

const PLAYER_TYPE = {
  1: '活跃玩家',
  2: '回归玩家',
  3: '新玩家',
};
const ACTIVE_APPOINTMENT_STATUS = 1; // 活动预约期间
const ACTIVE_PROCEED_STATUS = 2; // 活动进行期间

export default {
  name: 'RecallTeamActive',
  components: {
    Header,
    Footer,
    Login,
    Os
  },
  data() {
    return {
      headerConfig,
      gameName: 'snail',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      rechargeUrl: 'https://pay.qingcigame.com/pay?gameId=39',
      loginTypes: ["sms", "password"],
      autoOpenOS: true,
      preloadingShow: true,
      logger: null,
      card_id: '',
      code: '',
      auth_code: '',
      friend_id: '',
      shareLink: '',
      recallShareImg: '',

      // 弹窗
      preventShow: false, // 全局遮罩
      snailRoleSelect: false, // 角色选择
      findTeamShow: false, // 寻找队伍弹窗
      qqGroupShow: false, // QQ群
      detailShow: false, // 召回绑定——详情弹窗
      recallWechatShareShow: false, // 召回绑定——微信分享弹窗
      recallNotWechatShareShow: false, // 召回绑定——非微信分享弹窗
      recallFailedMyselfShow: false, // 召回绑定——自己召回自己弹窗
      recallFailedFullStrengthShow: false, // 召回绑定——已有好友弹窗
      recallFailedHasTeamShow: false, // 召回绑定——已有队伍弹窗
      recallFailedMismatchConditionShow2: false, // 召回绑定——都是回归玩家
      acceptInvitationShow: false, // 召回绑定——邀请弹窗

      // 错误提示
      crossChannelShow: false, // 跨渠道弹窗
      notGiftToOneselfShow: false, // 不能自己赠送自己弹窗
      collectedAndTakenAwayShow: false, // 已被领取和被带走弹窗
      photonStartedShow: false, // 光子服已开始弹窗
      teamWechatShareShow: false, // 新春活动_花灯——微信分享弹窗
      teamNotWechatShareShow: false, // 新春活动_花灯——非微信分享弹窗
      teamPlayerInfoShow: false, // 新春活动_花灯——玩家信息弹窗
      teamKickOutTipShow: false, // 新春活动_花灯——玩家被踢出队伍弹窗
      teamExitShow: false, // 新春活动_花灯——退出队伍弹窗
      teamBindRoleConfirmShow: false, // 新春活动_花灯——绑定角色确认弹窗
      teamPointsRecordShow: false, // 新春活动_花灯——积分记录弹窗
      teamNotPointsRecordShow: false, // 新春活动_花灯——积分记录弹窗 无积分
      teamJoinFailedFullStrengthShow: false, // 新春活动_花灯——入队失败(满员)
      teamJoinFailedHasTeamShow: false, // 新春活动_花灯——入队失败(已有队伍)
      teamJoinFailedMyselfShow: false, // 新春活动_花灯——入队失败(自己邀请自己)
      teamInvitationJoinShow: false, // 新春活动_花灯——邀请入队弹窗
      teamInvitationConfirmShow: false, // 新春活动_花灯——邀请入队确认弹窗

      cooperationShow: false, // 奖励弹窗——启航携手礼包
      crystalShow: false, // 奖励弹窗——奇点水晶礼包
      luckyShow: false, // 奖励弹窗——组队幸运礼包
      valuablesShow: false, // 奖励弹窗——贵重物品详情
      activityBenefitsShow: false, // 奖励弹窗——运营活动福利礼包
      giftCardsShow: false, // 奖励弹窗——赠送礼包卡
      acceptGiftConfirmShow: false,
      recallActiveInfo: {},
      teamActiveInfo: {},
      memberNum: 0,
      curPlayerInfo: {},
      invitePartnerInfo: {},

      // 是否需要二次同意
      needInvitationConfirm: false,

      roleList: [],
      selectedRoleID: null,
      isActiveAppointment: true, // 默认在预约期

      recallSharePlayerInfo: {},
      teamInvitationNum: 0,
      teamLevel: 0,
      teamScore: 0,
      scoreList: [],
      rewardLevel: 0,
      rewardList: [],
      selectedRoleInfo: {},
      qqNumber: '',
      qqLink: '',
      wechatLink: '',
      pageLink: '',
      cardList: [
        { id: 1, name: '蜗灯', num: 0, active: false },
        { id: 2, name: '鹂灯', num: 0, active: false },
        { id: 3, name: '呱灯', num: 0, active: false },
        { id: 4, name: '眼灯', num: 0, active: false },
        { id: 5, name: '猴灯', num: 0, active: false },
      ],
      cardInfo: { id: 1, name: '蜗灯', num: 0, active: false },
      cardAccpetInfo: { id: 1, name: '蜗灯', num: 0, active: false },
      timeAndCheckStartInfo: {
        formalStarted: false,
        photonStarted: false
      }, // 活动开始时间
      timeCheckNoStartMsg: {
        enabled: false,
        msg: '',
        black: ['activityBenefitsShow', 'teamNotPointsRecordShow', 'teamPointsRecordShow', 'giftCardsShow']
      },
      shareCopy: {
        title: '最强蜗牛丨新春灯火会',
        desc: '集5灯，兑新春好礼！老灯快来助蜗一臂之力！',
        linkText: '集5灯，兑新春好礼！老灯快来助蜗一臂之力！'
      },
      aspectRatio: ''
    }
  },
  async created() {
    // 获取服务器时间并判断开服状态（注意 await）
    this.timeAndCheckStartInfo = await this.onGetTimeAndCheckStart();
    if (!this.timeAndCheckStartInfo.formalStarted) {
      this.timeCheckNoStartMsg.enabled = true
      this.timeCheckNoStartMsg.msg = `活动暂未开启，2月13日05:00开启`
    }
    if (!this.timeAndCheckStartInfo.photonStarted) {
      this.timeCheckNoStartMsg.enabled = true
      this.timeCheckNoStartMsg.msg = `活动还未开始
光子服2月6日05:00活动开启
正式服2月13日05:00活动开启`
    }

    this.pageLink = window.location.href;

    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.key = urlParams.get('key');
    this.card_id = urlParams.get('card_id');
    console.log('created', this.card_id);
    this.auth_code = urlParams.get('auth_code');
    const queryUA = urlParams.get('ua');
    urlParams.delete('key');
    urlParams.delete('card_id');
    urlParams.delete('auth_code');
    urlParams.delete('ua');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState(null, '', newUrl);

    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 创建一个数组，长度为6，里面元素是空对象

    // 初始化
    this.onInitDate(true);

    // 埋点
    const bl = buriedLogger('snail', '新春活动_花灯');
    this.logger = bl;

    if (queryUA === 'snail') {
      this.rechargeUrl = 'https://pay.qingcigame.com/pay?gameId=39&ua=snail';
    }
    this.setShare({
      uri: this.pageLink,
      link: this.pageLink,
      title: this.shareCopy.title,
      imgUrl: "https://download4.qcplay.com/qcgame-api/tgDlZ6pJbG7UTyu6QAzYBDpFgnRoe0G7TDjCapHv.png",
      desc: this.shareCopy.desc,
    });
  },
  props: {
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick, true);
    this.onAdapt()


    // const el = document.createElement('div');
    // document.body.appendChild(el);

    // eruda.init({ container: el, useShadowDom: true });
  },
  computed: {
    roleName() {
      // 当区组为空时, 角色名为空
      if (this.roleList.length === 0) return
      let roleName = this.selectedRoleID
        ? this.roleList.find(item => item.role_id === this.selectedRoleID).role_name
        : "";
      return roleName;
    },
    finallyScore() {
      if (!this.activeInfo.team) {
        return 0;
      }
      const num = this.packageList[9].has_get_time;
      if (num === 20) {
        return 10000;
      }
      return this.teamScore - num * 10000;
    },
    finallyProcess() {
      if (!this.finallyScore) {
        return 0;
      }
      return Math.min((this.finallyScore / 10000) * 100, 100);
    },
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.user_id && oldValue.user_id) {
          // TAG: 注销的时候
          this.clearDate();
          this.onInitDate();
        } else if (newValue.user_id !== oldValue.user_id) {
          this.lightItemClick(0)
          if (oldValue.user_id) {
            console.log('初始登陆/切换角色')
            // TAG: 初始登陆/切换角色的时候
            this.clearDate();
            this.onInitDate();
          }
          this.setUserInfo({ ...this.userInfo });
        }
      }
    }
  },
  methods: {
    onAdapt() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const aspectRatio = Number((width / height).toFixed(3));
      console.log('aspectRatio', aspectRatio);

      // 按规则添加
      if (aspectRatio >= 0.63) {
        this.aspectRatio = 'adapt-2';
      } else if (aspectRatio >= 0.585) {
        this.aspectRatio = 'adapt-1';
      } else if (aspectRatio >= 0.5) {
        this.aspectRatio = 'adapt-3';
      } else if (aspectRatio >= 0.4) {
        this.aspectRatio = 'adapt-4';

      }
    },
    // 获取服务器时间 + 判断光子服/正式服是否开始
    async onGetTimeAndCheckStart() {
      // 取本地时间并构造接口同款对象
      function buildLocalTimeResponse() {
        const pad = n => String(n).padStart(2, '0');
        const d = new Date();

        const time =
          `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
          `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

        return {
          code: 200,
          message: 'ok',
          data: { time }
        };
      }


      // // 开始时间（按需改）
      // const targetDate = new Date('2026/02/06 04:59:59');       // 光子服开始
      // const formalTargetDate = new Date('2026/02/13 04:59:59'); // 正式服开始
      const targetDate = new Date('2024/01/13 04:59:59');       // 光子服开始
      const formalTargetDate = new Date('2026/01/13 04:59:59'); // 正式服开始

      const response = await onGetTimeAPI({});
      // const response = buildLocalTimeResponse();
      console.log('buildLocalTimeResponse', response)
      if (response.code !== 200) {
        this.onToast(response.message);
        return { photonStarted: false, formalStarted: false, now: null };
      }

      const serverTimeStr = response.data && response.data.time;
      if (!serverTimeStr) {
        return { photonStarted: false, formalStarted: false, now: null };
      }

      // 保存服务器时间（如果你需要）
      this.data = this.data || {};
      this.$set(this.data, 'time', serverTimeStr);
      // 兼容 Safari：把 "YYYY-MM-DD HH:mm:ss" 转成 "YYYY/MM/DD HH:mm:ss"
      const now = new Date(serverTimeStr.replace(/-/g, '/'));

      const photonStarted = now.getTime() >= targetDate.getTime();
      const formalStarted = now.getTime() >= formalTargetDate.getTime();
      return { photonStarted, formalStarted, now, serverTimeStr };
    },
    //接收花灯
    async onGetInitLightGetAPI() {
      const response = await onGetInitLightGetAPI({ key: this.key, card_id: this.card_id });
      this.closePopup('acceptGiftConfirmShow');
      this.card_id = ''
      this.key = ''
      switch (response.code) {
        case 200:
          this.onToast('领取成功');
          this.onInitDate();
          break;
        case 401:
          this.changeLoginPopup(true);
          // 很抱歉，请先登录
          break;
        case 406:
          // 两种场景：无效链接 / 花灯数量不足无法送出
          this.showPopup('collectedAndTakenAwayShow');
          break;
        case 408:   // 跨渠道
          this.showPopup('crossChannelShow');
          this.onToast(response.message);
          break;
        case 410:
          // 同一个账号
          this.showPopup('notGiftToOneselfShow');
          break;
        default:
          this.onToast(response.message);
      }

    },
    // 接受花灯初始
    async onGetInitLightHelpDataAPI() {
      console.log('onGetInitLightHelpDataAPI', this.key, this.card_id);
      const response = await onGetInitLightHelpDataAPI({ key: this.key, card_id: this.card_id, access_token: this.userInfo.access_token });
      if (response.code === 200) {
      } else {

      }
    },
    lightItemClick(index) {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true)
      }
      if (this.userInfo.rid === undefined) {
        this.changeOsPopup(true);
        return;
      }
      if (this.timeCheckNoStartMsg.enabled) {
        this.onToast(this.timeCheckNoStartMsg.msg);
        return
      }
      // 先把全部置为 false
      this.cardList.forEach((item, i) => {
        this.$set(this.cardList, i, { ...item, active: false });
      });
      this.$set(this.cardList, index, { ...this.cardList[index], active: true });
      this.cardInfo = this.cardList[index];
      console.log(this.cardInfo, this.cardList)
    },
    // 事件委托
    handleGlobalClick(e) {
      let el = e.target;
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute('data-snail-report-name')) {
          const reportName = el.getAttribute('data-snail-report-name');
          this.logger.sum(`新春活动_花灯_${reportName}`);
          break;
        }
        el = el.parentNode;
      }
    },
    // 生产赠送参数
    async onGetInitLightCodeAPI() {

      if (!this.userInfo.account) {
        return this.changeLoginPopup(true)
      }
      if (this.userInfo.rid === undefined) {
        this.changeOsPopup(true);
        return;
      }
      if (this.timeCheckNoStartMsg.enabled) {
        this.onToast(this.timeCheckNoStartMsg.msg);
        return
      }
      Indicator.open();
      if (this.cardInfo.num <= 0) {
        setTimeout(() => {
          Indicator.close();

        }, 500)
        this.onToast('花灯库存不足，快去游戏内进货吧~');
        return
      }
      const response = await onGetInitLightCodeAPI({ card_id: this.cardInfo.id, });
      if (response.code === 200) {
        this.cardInfo.key = response.data.key;
        if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
          this.isSetShare(true)
          this.recallWechatShareShow = true;
          this.logger.sum('新春活动_花灯-微信分享引导遮罩')
          Indicator.close();
          return
        }
        // this.isSetShare()
        this.initShareData()
      } else {
        this.onToast(response.message);
        Indicator.close();
      }
    },
    // 一键刷新
    async onGetInitLighiDataRefreshAPI() {

      if (!this.userInfo.account) {
        return this.changeLoginPopup(true)
      }
      if (this.userInfo.rid === undefined) {
        this.changeOsPopup(true);
        return;
      }
      Indicator.open();
      const response = await onGetInitLighiDataRefreshAPI()
      Indicator.close();
      if (response.code === 200) {
        const info = (response && response.data && response.data.info) || []; // [1,3,1,1,4]

        // 合并：按下标把 info 写入 num，其它字段保留
        const list = this.cardList.map((item, i) => ({
          ...item,
          num: info[i] != null ? info[i] : item.num
        }));

        // 整体替换，保证响应式更新
        this.$set(this, 'cardList', list);
      } else {
        this.onToast(response.message);
      }
    },
    maskMiddle4(str) {
      if (str == null) return '';
      const s = String(str);
      if (s.length <= 8) return s; // 不够就不处理
      return s.slice(0, 4) + '***' + s.slice(-4);
    },
    // 初始化
    onInitDate(isFirst = false) {
      onGetInitLightDataAPI().then(response => {
        this.onInitDataCallback({ ...response, needAccount: false });
        if (response.code !== 200) {
          this.changeLoginPopup(true)
          !isFirst && this.onToast(response.message);
          return;
        }

        // 合并：把 info 对应位置的值写到 num
        this.cardList = this.cardList.map((item, index) => {
          return {
            id: index + 1,
            name: item.name,
            active: item.active,
            num: response.data.activity.card.info[index] != null ? response.data.activity.card.info[index] : item.num
          };
        });
        this.lightItemClick(0)
        this.scoreList = response.data.activity.card.record.map((item, index) => {
          return { ...item, remark: this.maskMiddle4(item.remark) }
        })
        // this.scoreList = response.data.activity.card.record;
        this.cardList[0].active = true;
        this.cardInfo = this.cardList[0];
        this.qqNumber = this.activeInfo.qq;
        this.qqLink = this.activeInfo.qq_link;
        this.selectedRoleID = response.data.user_info.rid
        this.wechatLink = this.activeInfo.url_scheme;
        // 光子服开启
        if (response.data.user_info.game_id === 26 && this.timeAndCheckStartInfo.photonStarted) this.timeCheckNoStartMsg.enabled = false;
        // game_id == 26 时：
        // 1) 如果本地已记录弹过 photonStartedShow：不弹窗，直接继续执行下面的接收逻辑
        // 2) 如果没弹过：弹 photonStartedShow 并记录，然后 return（不执行下面接收逻辑，等你关弹窗再走）
        if (response.data.user_info.game_id == 26) {
          const hasShown = localStorage.getItem('photonStartedShow') === '1';
          if (!hasShown) {
            this.showPopup('photonStartedShow');
            return;
          }
        }
        // 只有“已弹过/不是26服”才会继续走到这里
        if (
          this.card_id != null && this.card_id !== '' && this.card_id !== 'undefined' && this.card_id !== 'null' &&
          this.key != null && this.key !== '' && this.key !== 'undefined' && this.key !== 'null'
        ) {
          this.onGetInitLightHelpDataAPI();
          this.showPopup('acceptGiftConfirmShow');
          this.cardAccpetInfo = this.cardList[this.card_id - 1];
        }
      });
    },
    clearDate() {
      this.teamActiveInfo = {};
      this.recallActiveInfo = {};
      this.memberNum = 0;
      this.roleList = [];
      this.scoreList = [];
      this.rewardLevel = 0;
      this.rewardList = [];
      this.selectedRoleInfo = {};
      this.recallShareImg = '';
      this.teamInvitationNum = 0;
      this.teamLevel = 0;
      this.shareCopy = {
        title: '最强蜗牛丨新春灯火会',
        desc: '集5灯，兑新春好礼！老灯快来助蜗一臂之力！',
        linkText: '集5灯，兑新春好礼！老灯快来助蜗一臂之力！'
      }
      this.cardList = [
        { id: 1, name: '蜗灯', num: 0, active: false },
        { id: 2, name: '鹂灯', num: 0, active: false },
        { id: 3, name: '呱灯', num: 0, active: false },
        { id: 4, name: '眼灯', num: 0, active: false },
        { id: 5, name: '猴灯', num: 0, active: false }
      ]

      this.cardAccpetInfo = { id: 1, name: '蜗灯', num: 0, active: false }
    },
    downloadApp() {
      window.location.href = this.downloadUrl;
    },
    // 去下载
    toDownload() {
      this.downloadApp();
    },
    goLink(url) {
      if (url === '') return
      Indicator.open();
      setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    // 跳转到首页
    toIndex(popupName) {
      this.closePopup(popupName);
      this.recallSharePlayerInfo = {};
      const { protocol, host } = window.location;
      window.location.href = `${protocol}//${host}/snail/springFestival/anniversary${getRandomString()}`;
    },
    openFindTeamShow() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.logger.sum('新春活动_花灯_寻找搭子按钮');
      this.showPopup('findTeamShow');
    },
    toGroupOfQQ() {
      if (wechatBrowser()) {
        this.closePopup('recallFailedMismatchConditionShow2');
        this.closePopup('findTeamShow');

        this.showPopup('qqGroupShow');
      } else {
        window.location.href = this.qqLink;
      }
    },
    toGroupOfWechat() {
      window.location.href = this.wechatLink;
    },

    // 微信分享
    isSetShare(is_wx) {
      const { protocol, host } = window.location;
      var enterLink = `${protocol}//${host}/snail/springFestivalActiveLight/enter${getRandomString()}`;
      if (is_wx == true) {
        enterLink = `${protocol}//${host}/snail/springFestivalActiveLight/enter${getRandomString()}` + '?card_id=' + this.cardInfo.id + '&key=' + this.cardInfo.key;
      }
      console.log('进入微信分享连接生成', enterLink);
      this.setShare({
        link: enterLink,
        title: '最强蜗牛丨送你一盏灯',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/tgDlZ6pJbG7UTyu6QAzYBDpFgnRoe0G7TDjCapHv.png',
        desc: `这可是我挚爱的“${this.cardInfo.name}”，送给你了！有空记得请我qia饭~`,
      })
    },
    initShareData() {
      // if (!this.activeInfo.invite.is_start) {
      //   return;
      // }
      try {
        const { protocol, host } = window.location;
        this.shareLink = `${protocol}//${host}/snail/springFestivalActiveLight/enter${getRandomString()}?card_id=${this.cardInfo.id}&key=${this.cardInfo.key}`;

        this.shareCopy = {
          title: this.shareCopy.title,
          desc: `这可是我挚爱的“${this.cardInfo.name}”，送给你了！有空记得请我qia饭~`,
          linkText: `这可是我挚爱的“${this.cardInfo.name}”，送给你了！有空记得请我qia饭~`,
        }
        this.qrcode('recall-qrcode', `${this.shareLink}`);

        setTimeout(() => {
          this.generateRecallShareImage();
          setTimeout(() => {
            this.showPopup('recallNotWechatShareShow');
            Indicator.close();
          }, 600)
        }, 200)
      } catch (err) {
        Indicator.close();
        // 错误信息
        console.log('召回分享初始化失败', err);
      }
    },
    // 生成二维码
    qrcode(id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: '#eee4d4',
        colorLight: '#c5a790'
      });
    },
    onCopy(id) {
      const clipboard = new Clipboard(`#${id}`);
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
    },
    // 分享图片设置
    async generateRecallShareImage() {
      await generateCanvasImage(this.$refs.recallImageDom)
        .then((canvas) => {
          this.recallShareImg = null
          this.recallShareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('召回分享图生成成功');
        })
        .catch((err) => {
          console.log('召回分享图生成失败', err.message);
        });
    },
    closeWechatShare(popupName) {
      this.closePopup(popupName);
      window.history.replaceState(null, '', window.location.pathname);
    },
    // 接受邀请
    async acceptInvitation() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await recallBindPlayerAPI({ code: this.code });
      switch (response.code) {
        case 200:
          this.onToast(response.message);
          this.closePopup('acceptInvitationShow');
          this.onInitDate();
          break;
        case 401:
          this.changeLoginPopup(true);
          // 很抱歉，请先登录
          break;
        case 406:
          // 两种场景：无效链接 / 花灯数量不足无法送出
          this.showPopup('collectedAndTakenAwayShow');
          break;
        case 408:   // 跨渠道
          this.showPopup('crossChannelShow');
          this.onToast(response.message);
          break;
        case 410:
          // 同一个账号
          this.showPopup('notGiftTo0neselfShow');
          break;
        default:
          this.onToast(response.message);
      }

      this.onPreventClose();
      this.closePopup('acceptInvitationShow');
      this.recallSharePlayerInfo = {};
    },
    // 查看更多积分
    onMorePoints() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (this.userInfo.rid === undefined) {
        this.changeOsPopup(true);
        return;
      }
      if (this.timeCheckNoStartMsg.enabled) {
        this.onToast(this.timeCheckNoStartMsg.msg);
        return
      }
      if (this.activeInfo.card.record.length > 0) {
        this.showPopup('teamPointsRecordShow');
      } else {
        this.showPopup('teamNotPointsRecordShow');
      }
    },
    // 跳转到充值网站
    toRecharge() {
      window.location.href = this.rechargeUrl;
    },
    // 角色选弹窗
    async onBindRolePopup() {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      // 获取角色信息 打开角色选择弹窗
      const roleResponse = await GetRoleList({
        account: this.userInfo.account,
        page_id: PAGE_ID[this.gameName],
        app_id: APP_ID[this.gameName]
      });

      if (Number(roleResponse.code) === 200) {
        // 正式服ID
        const serverIds = GAME_AREA[this.gameName][1].id;
        let data = roleResponse.data[serverIds] || [];
        this.roleList = data['android'];
        this.selectedRoleID = null;
        this.selectedRoleInfo = {};
        this.showPopup("snailRoleSelect");
      }
    },
    loginSuccess() {
      console.log('登录成功');
    },
    osCancell() {
    },
    async getSelectInfo(selectInfo) {
      console.log('selectInfo', selectInfo);
      // 选中的区服
      const game_id = selectInfo && selectInfo.game_id;

      // 获取服务器时间并判断开服状态（注意 await）
      const { photonStarted, formalStarted } = await this.onGetTimeAndCheckStart();
      // 光子服
      if (game_id === 26 && !photonStarted) return this.onToast('光子服活动暂未开启');
      // 正式服
      if (game_id === 39 && !formalStarted) return this.onToast('活动暂未开启，2月13日05:00开启');
      // 光子服开启
      if (game_id === 26 && photonStarted) this.timeCheckNoStartMsg.enabled = false;
      // 其他初始化
      this.onInitDate();
      // this.setInitUserInfo(selectInfo)
    },
    // 格式化日期
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${month}-${day} ${hours}:${minutes >= 10 ? minutes : '0' + minutes}:${seconds >= 10 ? seconds : '0' + seconds}`;
    },
    openLoginByScore() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
      }
    },
    openLoginByPlayer() {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
      }
      this.onBindRolePopup()
    },
    // TAG: 其他简易封装的方法
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    // 打开遮罩
    onPreventShow() {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose() {
      Indicator.close();
      this.preventShow = false;
    },
    showPopup(name) {
      if (this.timeCheckNoStartMsg.enabled && this.timeCheckNoStartMsg.black.includes(name)) {
        return this.onToast(this.timeCheckNoStartMsg.msg);
      }
      this[name] = true;
    },
    closePopup(name) {
      const isPhotonPopup = name === 'photonStartedShow';
      const notShownYet = localStorage.getItem('photonStartedShow') !== '1';
      const canAcceptGift =
        this.card_id != null &&
        this.card_id !== '' &&
        this.card_id !== 'undefined' &&
        this.card_id !== 'null' &&
        this.key != null &&
        this.key !== '' &&
        this.key !== 'undefined' &&
        this.key !== 'null';

      // 仅当关闭 photonStartedShow 且未记录过 且 card_id&key存在时，转去弹确认框
      if (isPhotonPopup && notShownYet) {
        if (canAcceptGift) {
          this.onGetInitLightHelpDataAPI();
          this.showPopup('acceptGiftConfirmShow');
          this.cardAccpetInfo = this.cardList[this.card_id - 1];
        }
        this[name] = false;
        localStorage.setItem('photonStartedShow', '1');
        return;
      }
      if (name == 'acceptGiftConfirmShow') {
        this.key = ''
        this.card_id = ''
      }

      this[name] = false;
    },
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
}
</script>


<style lang="less" scoped>
@import url("./index.less");
</style>


// WEBPACK FOOTER //
// src/pages/snail/springFestivalActive/light/index.vue